<template>
    <div class="aa">
        <div class="factory-card">
            <div v-if="ifFacOrBr=='1'" class="factory-side">
                工厂信息
            </div>
            <div v-if="ifFacOrBr=='2'" class="factory-side">
                品牌信息
            </div>
            <div class="factory-content">
                <div class="factory-header">
                    <div class="factory-title">
                        {{ businessName }}
                    </div>

                    <div class="factory-rating">
                        <a-rate disabled :value="avgRating" allow-half/>
                        <span class="rating-score">{{ avgRating }}</span>
                        <a-button @click="handleStar" type="link" size="small"
                                  :disabled="businessLangId === 0 || baseInfo.lang  == 'EN'"
                                  style="font-size: 20px; line-height: 1;">⋮
                        </a-button>
                    </div>

                    <div class="factory-options">
                        <a-checkbox v-if="ifFacOrBr=='1'" v-model="indexStatus" @change="handleIndexChange" class="mr16"
                                    :disabled="businessLangId === 0">正经工厂
                        </a-checkbox>
                        <a-checkbox v-if="ifFacOrBr=='2'" v-model="indexStatus" @change="handleIndexChange" class="mr16"
                                    :disabled="businessLangId === 0">推荐品牌
                        </a-checkbox>
                        <a-input placeholder="排序" :disabled="!indexStatus || businessLangId === 0"
                                 v-model.number="indexSort" @blur="handleIndexSortSave"
                                 @keyup.enter="handleIndexSortSave"/>
                    </div>

                    <div class="factory-publish">
                        <span>发布状态</span>
                        <a-switch :checked="factoryStatus" :disabled="businessLangId === 0"
                                  @change="(checked) => handlePublishChange(checked, record)"/>
                    </div>
                    <a-button type="link" icon="arrow-left" @click="$router.push(ifFacOrBr == '2' ? { name: 'BRANDMANAGE' } : { name: 'FACTORYMANAGE' })"
                              style="margin-left: auto;">返回列表
                    </a-button>
                </div>

                <!--                 <a-button type="link" class="sync-btn">英译同步</a-button>-->
            </div>
        </div>
        <div style="background-color: #fff;" v-if="ifFacOrBr=='1'">
            <a-tabs :active-key="activeKey" :tab-position="tabPosition" @change="handleTabChange">
                <a-tab-pane key="1" tab="基础信息">
                    <div class="tabTitle" style="">
                        基础信息
                    </div>
                    <BaseInfoTab ref="tabRefs.baseInfo" :ifFacOrBr="ifFacOrBr" :initial-data="baseInfo"
                                 :company-list="tableDataFactory"
                                 :pinlei-list="pinleiTags" :gongyi-list="gongyiTags"
                                 :sales-channels-list="salesChannelsTags" :zhuying-list="zhuyingTags"
                                 @dirty="onDirtyChange" @saved="onFactorySaved"/>
                </a-tab-pane>
                <a-tab-pane key="2" tab="经营信息" :disabled="businessLangId === 0">
                    <div class="tabTitle" style="">
                        经营信息
                    </div>
                    <ManageInfoTab ref="tabRefs.manageInfo" :ifFacOrBr="ifFacOrBr" :initial-data="baseInfo"
                                   :brand-list="tableDataBrand" :daigong-list="daigongTags"
                                   @dirty="onDirtyChange" @saved="onFactorySaved"/>
                </a-tab-pane>
                <a-tab-pane key="3" tab="主营产品" :disabled="businessLangId === 0">
                    <div class="tabTitle" style="display: flex; align-items: center;">
                        <span>主营产品</span>
                        <a-button type="link" icon="arrow-left" @click="backToProductList()" style="margin-left: auto;"
                                  v-show="formActive">返回列表
                        </a-button>
                    </div>
                    <MainProductTab ref="tabRefs.mainProduct" :ifFacOrBr="ifFacOrBr" :initial-data="baseInfo"
                                    @view-change="onViewChange"
                                    @dirty="onDirtyChange" @saved="onFactorySaved"/>
                </a-tab-pane>
                <a-tab-pane key="4" tab="社会评价" :disabled="businessLangId === 0">
                    <div class="tabTitle" style="">
                        社会评价
                    </div>
                    <ReputationTab ref="tabRefs.reputation" :ifFacOrBr="ifFacOrBr" :pingjia-list="pingjiaTags"
                                   :lang="baseInfo ? baseInfo.lang : undefined"
                                   :initial-data="baseInfo" />
                </a-tab-pane>
                <a-tab-pane key="5" tab="品控溯源" :disabled="businessLangId === 0">
                    <div class="tabTitle" style="">
                        品控溯源
                    </div>
                    <QualityControlTab ref="tabRefs.qualityControl" :ifFacOrBr="ifFacOrBr" :initial-data="baseInfo"
                                       @dirty="onDirtyChange" @saved="onFactorySaved"
                                       :zhiliang-list="zhiliangTags" :shengchan-list="shengchanTags"
                                       :supply-list="supplyList" :featured-raw-material-tags="rawMaterialTags"/>
                </a-tab-pane>
                <a-tab-pane key="6" tab="工商信息" :disabled="businessLangId === 0">
                    <div class="tabTitle" style="">
                        工商信息
                    </div>
                    <BusinessInfoTab ref="tabRefs.businessInfo" :ifFacOrBr="ifFacOrBr" :initial-data="baseInfo"
                                     @dirty="onDirtyChange" @saved="onFactorySaved"/>
                </a-tab-pane>
            </a-tabs>
        </div>


        <div style="background-color: #fff;" v-if="ifFacOrBr=='2'">
            <a-tabs :active-key="activeKey" :tab-position="tabPosition" @change="handleTabChange">
                <a-tab-pane key="1" tab="基础信息">
                    <div class="tabTitle" style="">
                        基础信息
                    </div>
                    <BaseInfoTab ref="tabRefs.baseInfo" :ifFacOrBr="ifFacOrBr" :initial-data="baseInfo"
                                 :company-list="tableDataFactory"
                                 :pinlei-list="pinleiTags" :gongyi-list="gongyiTags"
                                 :sales-channels-list="salesChannelsTags" :zhuying-list="zhuyingTags"
                                 @dirty="onDirtyChange" @saved="onFactorySaved"/>
                </a-tab-pane>
                <a-tab-pane key="2" tab="社会评价" :disabled="businessLangId === 0">
                    <div class="tabTitle" style="">
                        社会评价
                    </div>
                    <ReputationTab ref="tabRefs.reputation" :ifFacOrBr="ifFacOrBr" :pingjia-list="pingjiaTags"
                                   :lang="baseInfo ? baseInfo.lang : undefined"
                                   :initial-data="baseInfo" />
                </a-tab-pane>
                <a-tab-pane key="3" tab="品控溯源" :disabled="businessLangId === 0">
                    <div class="tabTitle" style="">
                        品控溯源
                    </div>
                    <QualityControlTab ref="tabRefs.qualityControl" :ifFacOrBr="ifFacOrBr" :initial-data="baseInfo"
                                       @dirty="onDirtyChange" @saved="onFactorySaved" :company-list="tableDataBrand"
                                       :zhiliang-list="zhiliangTags" :shengchan-list="shengchanTags"
                                       :supply-list="supplyList" :featured-raw-material-tags="rawMaterialTags"/>
                </a-tab-pane>
                <a-tab-pane key="4" tab="主营产品" :disabled="businessLangId === 0">
                    <div class="tabTitle" style="display: flex; align-items: center;">
                        <span>主营产品</span>
                        <a-button type="link" icon="arrow-left" @click="backToProductList()" style="margin-left: auto;"
                                  v-show="formActive">返回列表
                        </a-button>
                    </div>
                    <MainProductTab ref="tabRefs.mainProduct" :ifFacOrBr="ifFacOrBr" :initial-data="baseInfo"
                                    @view-change="onViewChange"
                                    @dirty="onDirtyChange" @saved="onFactorySaved"/>
                </a-tab-pane>
                <!-- <a-tab-pane key="2" tab="经营信息">
                    <div class="tabTitle" style="">
                        经营信息
                    </div>
                    <ManageInfoTab ref="tabRefs.manageInfo" :ifFacOrBr="ifFacOrBr" :initial-data="baseInfo" :brand-list="tableDataBrand"
                        @dirty="onDirtyChange" />
                </a-tab-pane> -->
                <a-tab-pane key="5" tab="品牌信息" :disabled="businessLangId === 0">
                    <div class="tabTitle" style="">
                        品牌信息
                    </div>
                    <BusinessInfoTab ref="tabRefs.businessInfo" :ifFacOrBr="ifFacOrBr" :initial-data="baseInfo"
                                     @dirty="onDirtyChange" @saved="onFactorySaved"/>
                </a-tab-pane>
            </a-tabs>
        </div>

        <!-- 冻结期限 -->
        <a-modal :title="rateModal.title" :visible="rateModal.flag" width="500px" @ok="rateModal.onOk"
                 @cancel="rateModal.flag = false" :footer-style="{ textAlign: 'center' }">
            <div>
                <div>原评分: {{ avgRating }}</div>
                <a-rate disabled :default-value="avgRating" allow-half/>
                <div style="margin-top: 10px;">编辑评分</div>
                <div style="display: flex;align-items: center;">
                    <a-rate v-model="avgRatingNew" allow-half/>
                    <a-input style="width: 150px;margin: 0 10px;" v-model.number="avgRatingNew" type="text"/>
                    <a-button @click="()=>{avgRatingNew=0}" type="text">清除</a-button>
                </div>
                <div style="margin-top: 10px; display: flex; align-items: center;">
                    <span style="margin-right: 8px;">启用管理员评分</span>
                    <a-switch v-model="virtualTotalScoreStatus" />
                </div>
            </div>
        </a-modal>
        <!-- 回到顶部 -->
    <div
      @click="scrollToTop"
      title="回到顶部"
      style="position: fixed; bottom: 40px; right: 40px; z-index: 1000; width: 40px; height: 40px; border-radius: 50%; background: #2CBD9C; color: #fff; display: flex; align-items: center; justify-content: center; cursor: pointer; font-size: 20px; box-shadow: 0 2px 8px rgba(0,0,0,0.15);"
    >↑</div>
    </div>
</template>

<script>
    import BaseInfoTab from './child/BaseInfoTab.vue'
    import ManageInfoTab from './child/ManageInfoTab.vue'
    import MainProductTab from './child/MainProductTab.vue'
    import ReputationTab from './child/ReputationTab.vue'
    import QualityControlTab from './child/QualityControlTab.vue'
    import BusinessInfoTab from './child/BusinessInfoTab.vue'
    import {
        managerFactoryDetailApi,
        getBusinessEntitiesApi,
        getOssAuth,
        getTagCategoriesApi,
        updateFactoryRatingApi,
        updateFactoryStatusApi,
        updateFactoryIndexStatusApi,
        updateFactoryIndexSortApi
    } from "../../api/index";

    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css' // 使用 snow 主题
    import {
        get
    } from "sortablejs";

    export default {
        name: "FACTORYDETAIL",
        components: {
            BaseInfoTab,
            ManageInfoTab,
            MainProductTab,
            ReputationTab,
            QualityControlTab,
            BusinessInfoTab
        },
        data() {
            return {
                factoryStatus: false,
                indexStatus: false,
                indexSort: 0,
                avgRating: 0,
                avgRatingNew: 0,
                virtualTotalScoreStatus: false,
                businessLangId: 0,
                businessName: '',
                form: this.$form.createForm(this),
                editModel: {},
                baseInfo: {},
                tabPosition: 'left',
                orderDesc: "",
                editorOption: {
                    modules: {
                        toolbar: [
                            ['bold', 'italic', 'underline', 'strike'],
                            ['color', 'background'], // 颜色功能在这里
                            ['clean']

                        ],
                    },
                    placeholder: "请输入内容",
                    theme: 'snow'
                },
                rateModal: {
                    flag: false,
                    title: "",
                    onOk: () => {
                    },
                },
                tableDataFactory: [],
                tableDataBrand: [],

                pinleiTags: [],
                gongyiTags: [],
                salesChannelsTags: [],
			rawMaterialTags: [],
                zhuyingTags: [],

                supplyList: [],

                zhiliangTags: [],
                shengchanTags: [],
                daigongTags: [],

                // 评价身份标签
                pingjiaTags: [],
                ifFacOrBr: "1",
                formActive: false,
                activeKey: '1', // 默认激活第一个tab
                isDirty: false, // 当前tab是否未保存
                originalData: null, // API 加载的原始数据，用于 Tab 切换时恢复
                pendingLoads: 0, // 待完成的初始化 API 请求计数
                justSaved: false, // 刚刚保存完成，临时屏蔽脏检测
                lastSaveTime: 0, // 最后一次保存的时间戳
                processingTabSwitch: false, // 正在切换 Tab 恢复数据，忽略脏检测
                formData: {}, // 传给子组件的初始数据
                tabRefs: {}, // 存储所有子组件ref
            };
        },

        mounted() {
      // 获取类型和ID
      const {
        type,
        ifFacOrBr,
        id
      } = this.$route.params
      this.ifFacOrBr = ifFacOrBr
      // 获取工厂的  品类，工艺，和主营品类
      this.getCompanyLabel()
      this.getBrandData()
      this.getSupply()
      this.getTagsLabel()
      if (type == 'add') {
        this.pendingLoads++
        this.getCompanyData()
      } else if (type == 'edit') {
        this.pendingLoads++ // getData 里的 API
        this.pendingLoads++ // getCompanyData 由 getData 内部调用
        this.businessLangId = id
        this.getData()
      }

      // DOM 事件监听（this.$el 范围，离开时自动销毁）
      this._onInput = () => {
        if (this.pendingLoads > 0 || this.processingTabSwitch || this.justSaved) return
        this.isDirty = true
        window.__isEditingDirty = true
      }
      this._onChange = () => {
        if (this.pendingLoads > 0 || this.processingTabSwitch || this.justSaved) return
        this.isDirty = true
        window.__isEditingDirty = true
      }
      this.$nextTick(() => {
        if (this.$el) {
          this.$el.addEventListener('input', this._onInput)
          this.$el.addEventListener('change', this._onChange)
        }
      })

      // 浏览器原生 beforeunload（箭头函数保证 this 指向）
      this._onBeforeUnload = (e) => {
        if (this.isDirty) {
          e.preventDefault()
          e.returnValue = ''
        }
      }
      window.addEventListener('beforeunload', this._onBeforeUnload)

      window.__isEditingDirty = false
    },

    beforeDestroy() {
      if (this._onInput && this.$el) {
        this.$el.removeEventListener('input', this._onInput)
        this.$el.removeEventListener('change', this._onChange)
      }
      if (this._onBeforeUnload) {
        window.removeEventListener('beforeunload', this._onBeforeUnload)
      }
      window.__isEditingDirty = false
    },

    watch: {
      baseInfo: {
        deep: true,
        handler() {
          if (this.pendingLoads > 0 || this.processingTabSwitch || this.justSaved) return
          this.isDirty = true
          window.__isEditingDirty = true
        }
      },
      avgRatingNew(val) {
        if (val > 5) this.avgRatingNew = 5;
        if (val < 0) this.avgRatingNew = 0;
      }
    },

    activated() {
      // 从 keep-alive 缓存恢复时，检查路由参数是否变化
      const {
        type,
        ifFacOrBr,
        id
      } = this.$route.params
      const newBusinessLangId = type === 'edit' ? id : 0
      if (this.ifFacOrBr !== ifFacOrBr || this.businessLangId !== newBusinessLangId) {
        this.ifFacOrBr = ifFacOrBr
        if (type === 'add') {
          this.businessLangId = 0
          this.baseInfo = {}
          this.isDirty = false
          this.getCompanyData()
        } else if (type === 'edit') {
          this.businessLangId = id
          this.getData()
        }
        this.getCompanyLabel()
      }
    },

    // 导航离开由 Home.vue 的 onLabelClick/onMenuClick 统一拦截
    // 此处不再定义 beforeRouteLeave，避免重复弹窗

        methods: {

            scrollToTop() {
              const el = document.querySelector('.content_view') || document.documentElement
              if (el) el.scrollTo({ top: 0, behavior: 'smooth' })
            },

            finishPendingLoad() {
              this.pendingLoads--
              if (this.pendingLoads <= 0) {
                this.pendingLoads = 0
                this.isDirty = false
                window.__isEditingDirty = false
              }
            },

            // 恢复当前 tab 的表单数据为 API 加载的原始值
            restoreActiveTabData() {
              if (!this.originalData) return
              // 恢复 baseInfo（驱动子组件的 prop 和 v-model）
              this.baseInfo = JSON.parse(JSON.stringify(this.originalData))
              // 根据当前 tab key 找到对应的子组件 ref
              const tabKeyToRef = {
                '1': 'tabRefs.baseInfo',
                '2': this.ifFacOrBr === '1' ? 'tabRefs.manageInfo' : 'tabRefs.reputation',
                '3': this.ifFacOrBr === '1' ? 'tabRefs.mainProduct' : 'tabRefs.qualityControl',
                '4': this.ifFacOrBr === '1' ? 'tabRefs.reputation' : 'tabRefs.mainProduct',
                '5': this.ifFacOrBr === '1' ? 'tabRefs.qualityControl' : 'tabRefs.businessInfo',
                '6': 'tabRefs.businessInfo'
              }
              const refName = tabKeyToRef[this.activeKey]
              const ref = refName ? this.$refs[refName] : null
              if (ref) {
                if (ref.form) {
                  ref.form.resetFields()
                } else if (ref.resetData) {
                  ref.resetData()
                }
              }
              window.__isEditingDirty = false
            },

            // 返回产品列表
            backToProductList() {
                const ref = this.$refs['tabRefs.mainProduct'];
                if (ref) {
                    ref.handleBack();
                }
            },
            onViewChange(isTable) {
                this.formActive = !isTable;
                // 从编辑表单返回列表时清除脏标记
                if (isTable) {
                  this.isDirty = false
                  window.__isEditingDirty = false
                }
            },

            // 正经工厂 排序保存
            handleIndexSortSave() {
                if (this.indexSort === undefined || this.indexSort === null || this.indexSort === '') {
                    return;
                }
                updateFactoryIndexSortApi({
                    businessLangId: this.businessLangId,
                    sort: this.indexSort
                }).then(res => {
                    if (res.resultStatus) {
                        this.$message.success('排序保存成功');
                    } else {
                        this.$message.error('保存失败');
                    }
                }).catch(() => {
                    this.$message.error('保存失败');
                });
            },
            // 正经工厂 勾选切换
            handleIndexChange() {
                // 当前最新状态（勾选后的值）
                const checked = this.indexStatus;
                // 记录切换前的原始状态（取消时用）
                const oldStatus = !checked;

                let content = checked ?
                    "确认将当前工厂设置为正经工厂？" :
                    "确认取消【正经工厂】标记？";
                if (this.ifFacOrBr == 2) {
                    content = checked ?
                        "确认将当前品牌设置为推荐品牌？" :
                        "确认取消【推荐品牌】标记？";
                }
                this.$confirm({
                    title: "操作确认",
                    content: content,
                    okText: "确定",
                    cancelText: "取消",
                    onOk: () => {
                        this.indexStatus = checked;

                        // 调用接口更新（传 1/0）
                        this.updateIndexStatusApi(this.baseInfo.businessLangId);
                    },
                    onCancel: () => {
                        this.indexStatus = oldStatus;
                    }
                });
            },

            // 正经工厂 接口
            updateIndexStatusApi(businessLangId) {
                updateFactoryIndexStatusApi({
                    businessLangId: businessLangId,
                })
                    .then((res) => {
                        if (res.resultStatus) {
                            this.$message.success(
                                "修改成功"
                            );
                            this.editModel.flag = false;
                        } else {
                            // console.log("res", res);
                        }
                    })
                    .catch((error) => {
                        // console.log(error);
                    })
                    .finally(() => {
                        this.getData()
                    })
            },

            onDirtyChange(val) {
                if (typeof val !== 'boolean') return
                console.log('[onDirtyChange] val=' + val + ' justSaved=' + this.justSaved)
                if (this.justSaved) return
                if (val) {
                  this.isDirty = true
                  window.__isEditingDirty = true
                }
            },
            onFactorySaved(payload) {
                if (!this.businessLangId && payload && payload.businessLangId) {
                    this.businessLangId = payload.businessLangId;
                }
                this.lastSaveTime = Date.now()
                this.isDirty = false
                this.justSaved = true
                window.__isEditingDirty = false
                window.__justSaved = true
                // 子页维护的是本地副本，保存后重新拉取详情以更新父级快照
                this.getData()
                setTimeout(() => {
                  this.justSaved = false
                  window.__justSaved = false
                }, 3000)
            },
            handleTabChange(targetKey) {
                // 1. 相同tab不处理
                if (targetKey === this.activeKey) return

                // 每次点击主营产品 tab 都回到列表视图
                const mainProductKey = this.ifFacOrBr === '1' ? '3' : '4'
                if (targetKey === mainProductKey) {
                  const ref = this.$refs['tabRefs.mainProduct']
                  if (ref && ref.resetData) {
                    ref.resetData()
                  }
                }

                // 社会评价 tab 使用弹框编辑，不需要脏检测
                const reputationKey = this.ifFacOrBr === '1' ? '4' : '2'
                const isRepTab = this.activeKey === reputationKey

                // 2. 无未保存、刚刚保存完成、社会评价 tab：直接切换
                console.log('[handleTabChange] isDirty=' + this.isDirty + ' isRepTab=' + isRepTab)
                if (!this.isDirty || this.justSaved || window.__justSaved || isRepTab || (Date.now() - this.lastSaveTime < 1000)) {
                    // 从社会评价 tab 切换出去时，DOM input/change 监听器可能已标记 isDirty
                    // （社会评价的排序修改会冒泡触发 this._onChange），需重置以免后续 tab 切换误判
                    if (isRepTab) {
                        this.isDirty = false
                        window.__isEditingDirty = false
                    }
                    this.activeKey = targetKey
                    return
                }

                // 3. 有未保存：弹出确认框
                this.$confirm({
                    title: '提示',
                    content: '当前编辑内容未保存，确定要离开吗？未保存的修改将丢失',
                    okText: '离开',
                    cancelText: '暂不离开',
                    onOk: () => {
                        // 离开：恢复当前tab数据为原始值，然后切换
                        this.processingTabSwitch = true
                        this.restoreActiveTabData()
                        setTimeout(() => {
                          // 等所有 watch 队列（含子组件嵌套 watch）全部执行完
                          this.processingTabSwitch = false
                          this.isDirty = false
                          this.activeKey = targetKey
                        }, 0)
                    },
                    onCancel: () => {
                        // 暂不离开：留在当前tab
                    }
                })
            },

            //
            // 切换发布状态（带确认提示）
            handlePublishChange(checked, record) {
                // ✅ 修复：记录原始状态
                const oldStatus = this.factoryStatus;
                // 动态生成提示文案
                let content = '';
                if (checked == true) {
                    // 切换为 启用
                    content = '切换为启用状态，则当前数据用户前端可查看，确认变更当前数据状态？';
                } else {
                    // 切换为 禁用
                    content = '切换为禁用状态，则当前数据前端不可查看，确认变更当前数据状态？';
                }

                this.$confirm({
                    title: '操作确认',
                    content: content,
                    okText: '确定',
                    cancelText: '取消',
                    onOk: () => {
                        this.factoryStatus = checked;
                        this.updateStatusApi(this.baseInfo.businessLangId)
                    },
                    onCancel: () => {
                        this.factoryStatus = oldStatus;
                    }
                });
            },
            updateStatusApi(businessLangId) {
                updateFactoryStatusApi({
                    businessLangId: businessLangId,
                })
                    .then((res) => {
                        if (res.resultStatus) {
                            this.$message.success(
                                "修改成功"
                            );
                            this.editModel.flag = false;
                        } else {
                            // console.log("res", res);
                        }
                    })
                    .catch((error) => {
                        // console.log(error);
                    })
                    .finally(() => {
                        this.getData()
                    })
            },
            handleStar() {
                this.rateModal = {
                    flag: true,
                    title: "评分",
                    // data: data,
                    onOk: this.starEdit,
                }
            },
            // 切换发布状态（带确认提示）
            starEdit() {
                this.$confirm({
                    title: '操作确认',
                    content: `确认修改当前数据，修改成功将变更当前工厂口碑评分`,
                    okText: '确定',
                    cancelText: '取消',
                    onOk: () => {
                        this.handleStarNew()
                    },
                    onCancel: () => {
                        // 取消时，保持开关原来的状态不变
                        // console.log('已取消操作');
                    }
                });
            },
            handleStarNew() {
                updateFactoryRatingApi({
                    virtualTotalScore: this.avgRatingNew,
                    virtualTotalScoreStatus: this.virtualTotalScoreStatus ? 1 : 0,
                    businessLangId: this.businessLangId
                })
                    .then((res) => {
                        if (res.resultStatus) {
                            // 修改完评分，不需要刷新原评分
                            this.rateModal.flag = false;
                            this.$message.success(
                                "修改成功"
                            );
                        } else {
                            // console.log("res", res);
                        }
                    })
                    .catch((error) => {
                        // console.log(error);
                    })
            },
            handleSubmit(e) {

            },
            handleSelectChange(value) {
                // console.log(`selected ${value}`);
            },
            deletePaperSize(index) {
                this.list.splice(index, 1);
            },
            addPL() {
                // 添加品类标签
            },
            handleUpdataFile(e) {
                if (e.target.files.length) {
                    const file = e.target.files[0];
                    // console.log("file", file);
                    if (file) {
                        const form = new FormData();
                        form.append("file", file);
                        // console.log("form", form);
                        getOssAuth(form).then((res) => {
                            if (res.resultStatus) {
                                this.editModel.imageUrl = res.resultData.fileLink;
                            }
                        });
                    }
                }
            },
            getData() {
                managerFactoryDetailApi({
                    businessLangId: this.businessLangId,
                }).then((res) => {
                    if (res.resultStatus) {
                        const result = res.resultData;
                        this.avgRating = result.avgRating
                        this.factoryStatus = result.factoryStatus
                        this.businessName = result.businessName
                        this.businessId = result.businessId

                        this.indexStatus = result.indexStatus
                        this.indexSort = result.indexSort
                        this.avgRatingNew = result.virtualTotalScore
                        this.virtualTotalScoreStatus = result.virtualTotalScoreStatus === 1

                        this.$nextTick(() => {
                            this.originalData = JSON.parse(JSON.stringify(result))
                            this.baseInfo = result
                            this.$nextTick(() => {
                              this.isDirty = false
                              window.__isEditingDirty = false
                            })
                        })
                        this.getCompanyData()

                    } else {
                        this.$message.warn(res.errorMessage);
                    }
                }).finally(() => {
                  this.finishPendingLoad()
                });
            },

            // 获取公司列表
            getCompanyData(page = 1) {
                if (this.loading) {
                    return;
                }
                console.log(this.businessId)
                this.loading = true;
                getBusinessEntitiesApi({
                    pageNo: 1,
                    pageSize: 10000,
                    businessType: this.ifFacOrBr == 1 ? 'FACTORY' : 'BRABD',
                    businessStatus: true,
                    addStatus: true,
                    businessId: this.businessId ? this.businessId : undefined
                })
                    .then((res) => {
                        if (res.resultStatus) {
                            this.tableDataFactory = res.resultData.dataList || [];

                        } else {
                            this.tableDataFactory = [];
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    })
                    .finally(() => {
                        this.loading = false;
                        this.finishPendingLoad()
                    });
            },
            // 获取品牌列表
            // 经营信息
            // 自由品牌
            // 合作品牌  BRABD
            getBrandData() {
                getBusinessEntitiesApi({
                    pageNo: 1,
                    pageSize: 1000,
                    businessType: 'BRABD'
                })
                    .then((res) => {
                        if (res.resultStatus) {
                            this.tableDataBrand = res.resultData.dataList || [];

                        } else {
                            this.tableDataBrand = [];
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    })
                    .finally(() => {
                    });
            },
            // 改这里
            getSupply() {
                getBusinessEntitiesApi({
                    pageNo: 1,
                    pageSize: 1000,
                    businessType: 'SUPPLIER'
                })
                    .then((res) => {
                        if (res.resultStatus) {
                            this.supplyList = res.resultData.dataList || [];
                        } else {
                            this.tableData = [];
                        }
                    })
            },


            // 评价身份标签
            // pingjiaTags
            getTagsLabel() {
                getTagCategoriesApi({
                    tagTypeCategory: 'SOCIAL_IDENTITY'
                })
                    .then((res) => {
                        if (res.resultStatus) {
                            this.pingjiaTags = res.resultData[0].tags

                        } else {
                        }
                    })
            },

            getCompanyLabel() {
                console.log("ifFacOrBr" + this.ifFacOrBr)
                getTagCategoriesApi({
                    tagTypeCategory: this.ifFacOrBr == 1 ? 'FACTORY' : 'BRAND',
                })
                    .then((res) => {
                        if (res.resultStatus) {
                            // 把 resultData 转成 { tagCategoryId: tags数组 } 的结构
                            this.tagMap = {}
                            res.resultData.forEach(item => {
                                this.tagMap[item.tagCategoryId] = item.tags || []
                            })
                            let pinleiTags = [] // 品类的tags数组
                            let gongyiTags = [] // 工艺的tags数组
                            let zhuyingTags = []//主营的tags数组
                            let zhiliangTags = []// 质量认证
                            let shengchanTags = [] // 生产资质
                            let daigongTags = [] // 代工模式
                            let rawMaterialTags = [] // 特色原料
                            let salesChannelsTags = []
                            if (this.ifFacOrBr == 1) {
                                pinleiTags = this.tagMap[1] // 品类的tags数组
                                gongyiTags = this.tagMap[2] // 工艺的tags数组
                                zhuyingTags = this.tagMap[6] //主营的tags数组
                                zhiliangTags = this.tagMap[3] // 质量认证
                                shengchanTags = this.tagMap[4] // 生产资质
                                daigongTags = this.tagMap[5] // 代工模式
                                rawMaterialTags = this.tagMap[17] // 特色原料
                            } else {
                                pinleiTags = this.tagMap[7] // 品类的tags数组
                                gongyiTags = this.tagMap[8] // 工艺的tags数组
                                salesChannelsTags = this.tagMap[9] // 销售渠道tags数组
                                zhuyingTags = this.tagMap[10] //主营的tags数组
                                zhiliangTags = this.tagMap[15] //质量认证
                                rawMaterialTags = this.tagMap[16] // 特色原料
                            }

                            this.pinleiTags = pinleiTags
                            this.gongyiTags = gongyiTags
                            this.zhuyingTags = zhuyingTags

                            this.zhiliangTags = zhiliangTags
                            this.shengchanTags = shengchanTags
                            this.daigongTags = daigongTags
                            this.salesChannelsTags = salesChannelsTags
                            this.rawMaterialTags = rawMaterialTags
                            this.rawMaterialTags = rawMaterialTags
                        } else {
                        }
                    })
            }

        },

    }
</script>

<style lang="less" scoped>
    .ant-modal-footer {
        text-align: center !important;
    }

    /deep/ .ant-tabs .ant-tabs-left-bar .ant-tabs-tab,
    .ant-tabs .ant-tabs-right-bar .ant-tabs-tab {
        width: 120px !important;
        text-align: center;
        padding: 12px 8px !important;
        // background-color: #aff;
    }

    .tabTitle {
        width: 100%;
        height: 40px;
        background-color: #4182FF1A;
        font-size: 16px;
        color: #333;
        line-height: 38px;
        padding-left: 40px;
        font-weight: bold;
    }


    /* 主卡片 */
    .factory-card {
        background: #fff;
        display: flex;
        padding: 20px 20px 20px 24px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

        /* 左侧工厂信息 */

        .factory-side {
            width: 120px;
            font-size: 18px;
            font-weight: 600;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        /* 右侧内容 */

        .factory-content {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: space-between;

            /* 头部横向布局 */

            .factory-header {
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                gap: 20px;

                /* 工厂名称 */

                .factory-title {
                    font-size: 18px;
                    font-weight: 700;
                    color: #222;
                }

                /* 选项区 */

                .factory-options {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                }

                /* 评分区域 */

                .factory-rating {
                    display: flex;
                    align-items: center;
                    gap: 10px;

                    .rating-score {
                        font-size: 16px;
                        color: #333;
                        font-weight: 500;
                    }
                }

                /* 发布状态 */

                .factory-publish {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    color: #666;
                }
            }

            /* 英译同步 */

            .sync-btn {
                padding-left: 0;
                color: #1890ff;
            }
        }

    }

    /* 通用间距 */
    .mr16 {
        margin-right: 16px;
    }
</style>

<style>
/* 非 scoped：覆盖 Ant Design Tabs 内部样式 */
.aa .ant-tabs-left-bar {
    position: sticky !important;
    height: fit-content !important;
    float: none !important;
}
.aa .ant-tabs-left {
    display: flex !important;
    flex-direction: row !important;
}
.aa .ant-tabs-left-bar .ant-tabs-tab {
    float: none !important;
    display: block !important;
}
.aa .ant-tabs-left-content {
    flex: 1 !important;
    min-width: 0 !important;
}
.aa .factory-card {
    position: sticky !important;
    top: 0 !important;
    z-index: 10 !important;
}
.aa {
    overflow: visible !important;
}

<style>
/* non-scoped: only sticky, keep Ant Design layout */
.aa > .factory-card {
    position: sticky !important;
    top: 0 !important;
    z-index: 10 !important;
}
.aa .ant-tabs-left-bar {
    position: sticky !important;
}
.aa {
    overflow: visible !important;
}
</style>
